import f from "lodash/groupBy";
function h(t, r, e) {
  return {
    [e.rowKey]: r,
    [t]: r,
    height: e.groupRowHeight || 32,
    isGroup: !0
  };
}
function n(t, r, e) {
  if (!r.length)
    return t;
  const u = r[0], o = r.slice(1), c = f(t, u);
  return Object.entries(c).map((g) => {
    const [i, s] = g, y = h(u, i, e), p = n(s, o, e);
    return {
      ...y,
      [e.childKey]: p
    };
  });
}
function K({ rows: t, options: r }) {
  const e = Array.isArray(r.groupKey) ? r.groupKey : [r.groupKey];
  return n(t, e, r);
}
export {
  K as groupRows
};
//# sourceMappingURL=group.js.map
